"use strict";
exports.__esModule = true;
exports.traced = void 0;
var logs_1 = require("@ledgerhq/logs");
var env_1 = require("../../../env");
function traced(api) {
    var state = {
        reqId: 0,
        reqStartTime: new Map()
    };
    var startReqTrace = function () {
        state.reqId += 1;
        state.reqStartTime.set(state.reqId, Date.now());
        return state.reqId;
    };
    var stopReqTrace = function (reqId) {
        var reqStartTime = state.reqStartTime.get(reqId);
        if (reqStartTime === undefined) {
            (0, logs_1.log)("warn", "request start time not found for request id <".concat(reqId, ">"));
            return {
                duration: 0
            };
        }
        state.reqStartTime["delete"](reqId);
        return {
            duration: Date.now() - reqStartTime
        };
    };
    var proxy = new Proxy(api, {
        get: function (target, propKey, receiver) {
            if (typeof propKey === "symbol") {
                throw new Error("symbols not supported");
            }
            var targetValue = Reflect.get(target, propKey, receiver);
            if (typeof targetValue === "function") {
                return function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    var reqId = startReqTrace();
                    (0, logs_1.log)("network", formatMsg({ reqId: reqId, msg: "calling <".concat(propKey, ">") }), {
                        args: args
                    });
                    var result = targetValue.apply(this, args);
                    if (result instanceof Promise) {
                        return result
                            .then(function (answer) {
                            var duration = stopReqTrace(reqId).duration;
                            (0, logs_1.log)("network-success", formatMsg({ reqId: reqId, msg: "success", duration: duration }), (0, env_1.getEnv)("DEBUG_HTTP_RESPONSE") ? { answer: answer } : undefined);
                            return answer;
                        })["catch"](function (error) {
                            var duration = stopReqTrace(reqId).duration;
                            (0, logs_1.log)("network-error", formatMsg({ reqId: reqId, msg: "error", duration: duration }), { error: error });
                            throw error;
                        });
                    }
                    else {
                        var duration = stopReqTrace(reqId).duration;
                        (0, logs_1.log)("info", formatMsg({ reqId: reqId, msg: "sync result", duration: duration }), (0, env_1.getEnv)("DEBUG_HTTP_RESPONSE") ? { result: result } : undefined);
                        return result;
                    }
                };
            }
            else {
                return targetValue;
            }
        }
    });
    return proxy;
}
exports.traced = traced;
function formatMsg(_a) {
    var reqId = _a.reqId, msg = _a.msg, duration = _a.duration;
    var parts = [
        "solana req id: ".concat(reqId),
        msg !== null && msg !== void 0 ? msg : "",
        duration === undefined ? "" : "took ".concat(duration.toFixed(0), "ms"),
    ];
    return parts.join(", ");
}
//# sourceMappingURL=traced.js.map